export default __webpack_public_path__ + "static/media/truck_black.950f2660.svg";